import { render, staticRenderFns } from "./FilesAluno.vue?vue&type=template&id=45c12db0&scoped=true&"
import script from "./FilesAluno.vue?vue&type=script&lang=js&"
export * from "./FilesAluno.vue?vue&type=script&lang=js&"
import style0 from "./FilesAluno.vue?vue&type=style&index=0&id=45c12db0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c12db0",
  null
  
)

export default component.exports